export default __webpack_public_path__ + "static/media/logo-bottom.952efa9e.svg";